// Func = limiting Scope for this file
var lastScrollTop = 0;
	
function getMenu(menu_id){
	$.get( `${site_url}ajax/functions.php`, { operation: "getMenu", menu_id: menu_id }, function(data){
		$('.menu-view').html(data);
		$('.overlay').fadeIn();
		$('.menu-view').fadeIn();
		$('.menu-view').append('<div class="close" onclick="closePopup()"></div>');
	});
}
function closePopup() {
	$('.popup').fadeOut();
	$('.overlay').fadeOut();
}
(function(){

	$(document).ready(function () {

		$('.js-menu-lightbox').click(function () {
			var menu_id = $(this).attr("data-menu");
			getMenu(menu_id);
			return false;
		});

		$('.overlay').click(function () {
			closePopup();
		});
		$('.popup .close').click(function () {
			closePopup();
		});

	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				$('.burger').removeClass('white');
				$('.burger').addClass('black');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			$('.burger').removeClass('black');
				$('.burger').addClass('white');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}